class MultiSelect {
  constructor(container, config = {}) {
    this.container = container;
    this.select = container.querySelector('select');
    this.name = this.select.name;
    this.maxHeight = config.maxHeight || 200;
    this.container.dataset.name = this.name;

    this.selectors = {
      header: '.cls-multiselect-header',
      dropdown: '.cls-multiselect-dropdown',
      options: '.cls-multiselect-options',
      option: '.cls-multiselect-option',
      placeholder: '.cls-multiselect-placeholder',
      selectedCount: '.cls-multiselect-selected-count',
      arrow: '.cls-multiselect-arrow',
      checkmark: '.cls-multiselect-checkmark',
    }

    this.classnames = {
      header: 'cls-multiselect-header',
      headerTailwind: 'cls-bg-white cls-border cls-border-gray-300 cls-text-gray-900 cls-text-sm cls-rounded-lg hover:cls-ring-green-600 hover:cls-border-green-600 cls-flex cls-items-center cls-justify-between cls-gap-2 cls-w-full cls-px-3 cls-py-2 cls-outline-none hover:cls-outline-none',
      dropdown: 'cls-multiselect-dropdown',
      dropdownTailwind: 'cls-bg-white cls-border cls-border-gray-300 cls-text-gray-900 cls-text-sm cls-rounded-lg',
      options: 'cls-multiselect-options',
      option: 'cls-multiselect-option',
      placeholder: 'cls-multiselect-placeholder',
      selectedCount: 'cls-multiselect-selected-count',
      arrow: 'cls-multiselect-arrow',
      checkmark: 'cls-multiselect-checkmark',
      selected: 'is-selected',
      checked: 'is-checked',
      open: 'is-open',
    }

    this.init();
  }

  init() {
    this.renderHeader();
    this.renderDropdown();
    this.bindEvents();
    this.renderOptions();
    this.updateHeader();
  }

  renderHeader() {
    this.header = document.createElement('div');
    this.header.className = this.classnames.header + ' ' + this.classnames.headerTailwind;
    this.header.innerHTML = `
      <span class="${this.classnames.placeholder}">Select options...</span>
      <span class="${this.classnames.selectedCount}"></span>
      <span class="${this.classnames.arrow}"></span>
    `;
    this.container.appendChild(this.header);
  }

  renderDropdown() {
    this.dropdown = document.createElement('div');
    this.dropdown.className = this.classnames.dropdown + ' ' + this.classnames.dropdownTailwind;
    this.dropdown.innerHTML = `<div class="${this.classnames.options}"></div>`;
    this.optionsContainer = this.dropdown.querySelector(this.selectors.options);
    this.container.appendChild(this.dropdown);
  }

  renderOptions() {
    this.optionsContainer.innerHTML = '';
    Array.from(this.select.options).forEach(option => {
      if (!option.value) return;
      const div = document.createElement('div');
      div.className = `${this.classnames.option} ${option.selected ? this.classnames.selected : ''}`;
      div.dataset.value = option.value;
      div.innerHTML = `
        <span class="${this.classnames.checkmark} ${option.selected ? this.classnames.checked : ''}"></span>
        <span>${option.text}</span>
      `;
      div.addEventListener('click', (e) => this.toggleOption(e));
      this.optionsContainer.appendChild(div);
    });
  }

  toggleOption(e) {
    const optionEl = e.currentTarget;
    const value = optionEl.dataset.value;
    const selectOption = this.select.querySelector(`option[value="${value}"]`);
    selectOption.selected = !selectOption.selected;
    optionEl.classList.toggle(this.classnames.selected);
    optionEl.querySelector(this.selectors.checkmark).classList.toggle(this.classnames.checked);
    this.updateHeader();
    this.select.dispatchEvent(new Event('change'));
  }

  updateHeader() {
    const selected = Array.from(this.select.selectedOptions).length;
    const countEl = this.header.querySelector(this.selectors.selectedCount);
    const placeholder = this.header.querySelector(this.selectors.placeholder);
    //countEl.textContent = selected ? `${selected} selected` : '';
    countEl.textContent = Array.from(this.select.selectedOptions).map(option => option.text).join(', ');
    placeholder.style.display = selected ? 'none' : 'block';
  }

  bindEvents() {
    this.header.addEventListener('click', () => this.toggle());
    document.addEventListener('click', (e) => {
      if (!this.container.contains(e.target)) this.close();
    });
  }

  toggle() {
    this.container.classList.toggle(this.classnames.open);
    if (this.container.classList.contains(this.classnames.open)) {
      this.renderOptions();
    }
  }

  open() { this.container.classList.add(this.classnames.open); this.renderOptions(); }
  close() { this.container.classList.remove(this.classnames.open); }

  // Public methods
  getSelectedValues() {
    return Array.from(this.select.selectedOptions).map(opt => opt.value);
  }

  getSelectedLabels() {
    return Array.from(this.select.selectedOptions).map(opt => opt.text);
  }

  addOption(value, text, selected = false) {
    const option = new Option(text, value, selected, selected);
    this.select.appendChild(option);
  }

  destroy() {
    this.container.innerHTML = '';
    this.container.classList.remove(this.classnames.open);
  }
}

// Initialize
export default () => {
  document.querySelectorAll('.js-multiselect').forEach(container => {
    new MultiSelect(container);
  });
}
